/**
 * Route constants for the application.
 */
export const ROUTES = {
  HOME: '/',
  DASHBOARD_CUSTOMIZE: '/dashboard/customize',
  TENANTS: '/tenants',
  PROJECTS: '/projects',
  PROJECT_EDIT: '/projects/:id/edit',
  API_KEYS: '/api-keys',
  AGENTS: '/agents',
  AGENT_DETAIL: '/agents/:id',
  AGENT_NEW: '/agents/new',
  AGENT_EDIT: '/agents/:id/edit',
  SESSIONS: '/sessions',
  SESSION_DETAIL: '/sessions/:id',
  MEMORIES: '/memories',
  MEMORY_DETAIL: '/memories/:id',
  MEMORY_DEFINITIONS: '/memory-definitions',
  MEMORY_DEFINITION_NEW: '/memory-definitions/new',
  MEMORY_DEFINITION_DETAIL: '/memory-definitions/:id',
  MEMORY_POLICY: '/memory-policy',
  MEMORY_RULES: '/memory-rules',
  MEMORY_PIPELINE: '/memory-pipeline',
  MEMORY_QUARANTINE: '/memory-quarantine',
  SKILLS: '/skills',
  TOOLS: '/tools',
  TOOL_DETAIL: '/tools/:id',
  TOOL_NEW: '/tools/new',
  TOOL_EDIT: '/tools/:id/edit',
  WORKFLOWS: '/workflows',
  WORKFLOW_DETAIL: '/workflows/:id',
  WORKFLOW_NEW: '/workflows/new',
  WORKFLOW_EDIT: '/workflows/:id/edit',
  COMPOSER: '/composer',
  COMPOSER_DETAIL: '/composer/:id',
  SCHEDULES: '/schedules',
  SCHEDULE_DETAIL: '/schedules/:id',
  SCHEDULE_NEW: '/schedules/new',
  SCHEDULE_EDIT: '/schedules/:id/edit',
  INVESTIGATIONS: '/investigations',
  INVESTIGATION_DETAIL: '/investigations/:id',
  INVESTIGATION_NEW: '/investigations/new',
  INVESTIGATION_EDIT: '/investigations/:id/edit',
  INVESTIGATION_TEMPLATES: '/investigations/templates',
  INVESTIGATION_TEMPLATE_NEW: '/investigations/templates/new',
  INVESTIGATION_TEMPLATE_EDIT: '/investigations/templates/:id/edit',
  SAFETY_GATES: '/safety-gates',
  SAFETY_GATE_NEW: '/safety-gates/new',
  SAFETY_GATE_EDIT: '/safety-gates/:id/edit',
  APPROVAL_QUEUE: '/approval-queue',
  GUARDRAILS: '/guardrails',
  GUARDRAIL_BINDINGS: '/guardrails/bindings',
  GUARDRAIL_EXECUTIONS: '/guardrails/executions',
  MCP_SERVERS: '/mcp-servers',
  MCP_SERVER_DETAIL: '/mcp-servers/:id',
  MCP_SERVER_NEW: '/mcp-servers/new',
  MCP_SERVER_EDIT: '/mcp-servers/:id/edit',
  EXTERNAL_SYSTEMS: '/external-systems',
  EXTERNAL_SYSTEM_DETAIL: '/external-systems/:id',
  EXTERNAL_SYSTEM_NEW: '/external-systems/new',
  EXTERNAL_SYSTEM_EDIT: '/external-systems/:id/edit',
  TASKS: '/tasks',
  TASK_DETAIL: '/tasks/:id',
  TASK_NEW: '/tasks/new',
  EXTERNAL_TASK_SYSTEMS: '/external-task-systems',
  EXTERNAL_TASK_SYSTEM_NEW: '/external-task-systems/new',
  EXTERNAL_TASK_SYSTEM_EDIT: '/external-task-systems/:id/edit',
  MODEL_CATALOG: '/model-catalog',
  LLM_PROVIDER_CONFIGS: '/llm-configs',
  LLM_PROVIDER_CONFIG_NEW: '/llm-configs/new',
  LLM_PROVIDER_CONFIG_EDIT: '/llm-configs/:id/edit',
  USAGE_ANALYTICS: '/usage-analytics',
  SETTINGS_USER: '/settings/user',
  SETTINGS_TENANT: '/settings/tenant',
  CONNECTORS: '/connectors',
  CONNECTOR_DETAIL: '/connectors/:id',
  CONNECTOR_INSTANCE_NEW: '/connectors/:connectorId/instances/new',
  CONNECTOR_INSTANCE_DETAIL: '/connectors/instances/:instanceId',
  CONNECTOR_INSTANCE_EDIT: '/connectors/instances/:instanceId/edit',
  ORCHESTRATOR: '/orchestrator',
  ORCHESTRATOR_RUN: '/orchestrator/:agentId',
  AGENT_FUNCTIONS: '/agent-functions',
  AGENT_FUNCTION_NEW: '/agent-functions/new',
  AGENT_FUNCTION_DETAIL: '/agent-functions/:id',
  AGENT_FUNCTION_EDIT: '/agent-functions/:id/edit',
  AGENT_FUNCTION_REQUESTS: '/agent-functions/:id/requests',
  AGENT_FUNCTION_EXECUTE: '/agent-functions/execute',
  AGENT_FUNCTION_REQUEST_DETAIL: '/agent-functions/requests/:requestId',
  API_EXPLORER: '/api-explorer',
  API_EXPLORER_DETAIL: '/api-explorer/:slug',
  NOTIFICATIONS: '/notifications',
  EMAIL_TEMPLATES: '/settings/email-templates',
  LLM_METRICS: '/llm-metrics',
  WEB_AUTOMATION_SITES: '/web-automation/sites',
  WEB_AUTOMATION_SITE_DETAIL: '/web-automation/sites/:id',
  WEB_AUTOMATION_SITE_NEW: '/web-automation/sites/new',
  WEB_AUTOMATION_SITE_EDIT: '/web-automation/sites/:id/edit',
  WEB_AUTOMATION_RUNS: '/web-automation/runs',
  TRANSCRIPTION_PLAYGROUND: '/transcription/playground',
  TRANSCRIPTIONS: '/transcription/transactions',
  TRANSCRIPTION_DETAIL: '/transcription/transactions/:id',
  TRANSCRIPTION_HOW_TO_USE: '/transcription/how-to-use',
  DEVELOPER_HELP: '/help/developers',
  DEVELOPER_HELP_RECIPE: '/help/developers/:slug',
} as const;
